import { Injectable } from "@angular/core";
import { RefundType } from "../models/RefundType";

@Injectable()
export class RefundTypeService {

    nameof(id: number) {
        switch (id) {
            case RefundType.manual:
              return 'Manual';
            case RefundType.automatic:
              return 'Automatic';
            default:
              return '';
        }
    }
}